import icon from "../../assets/touch-pass.svg";
import type { Property } from "../../types";

export const touchPassSupport: Property = {
  id: "touchPassSupport",
  title: "touchPassSupport.title",
  icon,
};
